<template>
  <b-table
    class="s-table"
    show-empty
    hover
    responsive
    :striped="striped"
    :no-local-sorting="!localSorting"
    v-bind="extraBinds"
    v-on="$listeners"
  >
    <template #empty>
      <s-empty-list />
    </template>
    <template #empty-filtered>
      <s-empty-list />
    </template>
    <template #table-busy>
      <s-empty-list loading />
    </template>
    <template
      v-for="(slotContent, slotName) in $scopedSlots"
      #[slotName]="slotData"
    >
      <slot
        :name="slotName"
        v-bind="slotData"
      />
    </template>
  </b-table>
</template>

<script>
import extraBindsMixin from '@/components/mixins/extraBindsMixin';
/**
 * Tabela padrão do sistema.
 *
 * Componente de tabela que encapsula a tabela do bootstrap-vue e define as propriedades padrão que
 * são usadas em todas as tabelas do sistema.
 *
 * É possível passar qualquer propriedade, evento ou slot suportado para tabela do bootstrap-vue.
 * Qualquer configuração informada para este componente será diretemente repassada.
 *
 * Este componente define por padrão:
 *  - show-empty
 *  - hover
 *  - responsive
 *  - no-local-sorting
 *  - slot de conteúdo vazio e carregamento (slots empty, empty-filtered, table-busy)
 */
export default {
  props: {
    /**
     * Ativa ordenação local.
     * Equivalente a informar no-local-sorting="false"
     */
    localSorting: {
      type: Boolean,
      required: false,
      default: false,
    },
    striped: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  mixins: [
    extraBindsMixin,
  ],
};
</script>

<style lang="sass" scoped>
  .s-table
    position: relative
    ::v-deep
      thead tr th
        white-space: nowrap
        > div
          display: inline
</style>
